import { useContext } from 'react'
import { css, useTheme } from '@fable/theme'
import {
  Loader,
  Logo,
  PaginationContainer,
  PaginationContainerContext,
} from '@fable/components'
import { useErrorModal } from 'hooks'
import { ProfilePost } from './ProfilePost'
import Masonry from 'react-masonry-css'

const ProfilePostsList = () => {
  const { query, list, error } = useContext(PaginationContainerContext)
  const { breakpoints } = useTheme()
  const masonryGap = '20px'

  useErrorModal(error)

  if (query?.isLoading) {
    return (
      <Logo
        className={css`
          text-align: center;
        `}
        animate
        isIcon
      />
    )
  }

  return query.isFetched && !!list?.length ? (
    <Masonry
      breakpointCols={{
        default: 2,
        [breakpoints.mobileL]: 1,
      }}
      className={css`
        display: flex;
        padding: 0 20px;
        margin-left: -${masonryGap};
        width: auto;
      `}
      columnClassName={css`
        padding-left: ${masonryGap};
        background-clip: padding-box;

        > div {
          margin-bottom: ${masonryGap};
        }
      `}
    >
      {list?.map((post) => (
        <ProfilePost key={post.id} post={post} />
      ))}
    </Masonry>
  ) : null
}

const ProfilePosts = ({ profileUserId }: { profileUserId?: string }) =>
  profileUserId ? (
    <PaginationContainer
      queryArgs={['posts', profileUserId]}
      endpoint={`/users/${profileUserId}/user_posts`}
      limit={20}
      scrollLevel="fullPage"
    >
      <ProfilePostsList />
    </PaginationContainer>
  ) : (
    <Loader />
  )

export default ProfilePosts
